export class ConfigData {
  logoutUrl = '';
  myAccountUrl = '';
}

export interface IConfigurationService {
  getConfigs(): Promise<ConfigData>;
  getWindowOrigin(): string;
}

export class ConfigurationService implements IConfigurationService {
  private static configs: ConfigData;

  async getConfigs(): Promise<ConfigData> {
    if (ConfigurationService.configs) return Promise.resolve(ConfigurationService.configs);
    const data = await fetch(`${this.getWindowOrigin()}/home/config`, { credentials: 'include' });
    try {
      const jsonConfig = await data.json();
      ConfigurationService.configs = jsonConfig;
      return ConfigurationService.configs;
    } catch (ex) {
      return { logoutUrl: '', myAccountUrl: '' };
    }
  }

  getWindowOrigin(): string {
    if (process.env.NODE_ENV === 'development') {
      return `https://localhost:${process.env.REACT_APP_DEV_PORT}`;
    }
    if (process.env.NODE_ENV === 'production') {
      if (!window.location.origin) {
        (window.location as any).origin = `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? `:${window.location.port}` : ''
        }`;
      }
    }
    return window.location.origin;
  }
}
